import { apiClient } from '../../../shared/api/axios-instance'
import type { Category } from '../types/category.types'

export interface CreateCategoryData {
    name: string
    slug?: string
    parent_id?: number | null
    description?: string
    image?: string
    status?: 'active' | 'inactive'
}

export interface UpdateCategoryData {
    name?: string
    slug?: string
    parent_id?: number | null
    description?: string
    image?: string
    status?: 'active' | 'inactive'
}

const mapCategory = (item: any): Category => ({
    id: String(item.id),
    name: item.name,
    slug: item.slug,
    description: item.description,
    image: item.image_url || item.icon_url || undefined,  // CDN URL for display
    imageId: item.image || undefined,                     // document UUID for form re-submission
    parentId: item.parent_id || undefined,
    parentCategory: item.parent_category,
    productCount: item.products_count,
    status: item.status || (item.is_active ? 'active' : 'inactive'),
    createdAt: item.created_at,
})

const categoryService = {
    /**
     * Get all categories
     */
    async getCategories(): Promise<Category[]> {
        const response = await apiClient.get('admin/catalog/categories')
        return response.data.data.map(mapCategory)
    },

    /**
     * Get category details
     */
    async getCategory(id: string): Promise<Category> {
        const response = await apiClient.get(`admin/catalog/categories/${id}`)
        return mapCategory(response.data.data)
    },

    /**
     * Create a new category
     */
    async createCategory(data: CreateCategoryData): Promise<Category> {
        const response = await apiClient.post('admin/catalog/categories', data)
        return mapCategory(response.data.data)
    },

    /**
     * Update a category
     */
    async updateCategory(id: string, data: UpdateCategoryData): Promise<Category> {
        const response = await apiClient.put(`admin/catalog/categories/${id}`, data)
        return mapCategory(response.data.data)
    },

    /**
     * Delete a category
     */
    async deleteCategory(id: string): Promise<void> {
        await apiClient.delete(`admin/catalog/categories/${id}`)
    },
}

export default categoryService
